import styled from 'styled-components';

export const Img = styled.img``;

export const Text = styled.span`
  margin-left: 20px;
  font-size: 14px;
  color: ${({ theme }) => theme.simpleTooltip.white};
`;

export const Container = styled.div``;
